import React from 'react';
import { DollarSign, ChevronRight } from 'lucide-react';
import { useSales } from '../../../../contexts/SalesContext';
import { useNavigate } from 'react-router-dom';

export function CajaAlert() {
  const { sales } = useSales();
  const navigate = useNavigate();

  // Filtrar solo las ventas no pagadas
  const unpaidSales = sales?.filter(sale => 
    sale.payment_status === 'unpaid' || sale.payment_status === 'partial'
  ) || [];

  if (unpaidSales.length === 0) return null;

  const totalAmount = unpaidSales.reduce((acc, sale) => acc + (sale.total_amount - (sale.paid_amount || 0)), 0);

  return (
    <button 
      onClick={() => navigate('/caja')}
      className="w-full bg-red-50 hover:bg-red-100 p-4 rounded-lg shadow-sm flex items-center justify-between group"
    >
      <div className="flex items-center gap-3">
        <div className="bg-red-100 p-2 rounded-full">
          <DollarSign className="w-5 h-5 text-red-600" />
        </div>
        <div className="font-medium text-red-900">
          {unpaidSales.length} {unpaidSales.length === 1 ? 'venta' : 'ventas'} sin cobrar (${totalAmount.toLocaleString()})
        </div>
      </div>
      <ChevronRight className="w-5 h-5 text-red-600" />
    </button>
  );
} 